<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle">Glossary</h2>
<table class="table11">
<colgroup>
<col class="a30"/>
<col class="a70"/>
</colgroup>
<tbody>
<tr>
<td class="td1">AAA</td>
<td class="td1">Anti-Aircraft Artillery</td>
</tr>
<tr>
<td class="td1">AMU</td>
<td class="td1">Air Maintenance Unit</td>
</tr>
<tr>
<td class="td1">CASEVAC</td>
<td class="td1">Casualty Evacuation</td>
</tr>
<tr>
<td class="td1">EGAF</td>
<td class="td1">Egypt Air Force</td>
</tr>
<tr>
<td class="td1">EGDF</td>
<td class="td1">Egypt Defense Force (armed forces/army)</td>
</tr>
<tr>
<td class="td1">EGNF</td>
<td class="td1">Egypt Naval Force (Navy)</td>
</tr>
<tr>
<td class="td1">FRUS</td>
<td class="td1">Foreign Relations of the United States, a publication that constitutes the official record of the foreign policy of USA</td>
</tr>
<tr>
<td class="td1">GMT</td>
<td class="td1">Greenwich Mean Time</td>
</tr>
<tr>
<td class="td1">HQ</td>
<td class="td1">Headquarters</td>
</tr>
<tr>
<td class="td1">ILAF</td>
<td class="td1">Israel Air Force</td>
</tr>
<tr>
<td class="td1">ILAFI</td>
<td class="td1">ILAF Intelligence</td>
</tr>
<tr>
<td class="td1">ILDF</td>
<td class="td1">Israel Defense Force</td>
</tr>
<tr>
<td class="td1">ILDF Front A</td>
<td class="td1">HQ north sector facing Lebanon, Syria and Iraq</td>
</tr>
<tr>
<td class="td1">ILDF Front B</td>
<td class="td1">HQ Samaria sector facing Iraq and Jordan</td>
</tr>
<tr>
<td class="td1">ILDF Front C</td>
<td class="td1">HQ Judea sector facing Jordan and Egypt</td>
</tr>
<tr>
<td class="td1">ILDF Front D</td>
<td class="td1">HQ south sector facing Egypt and Jordan</td>
</tr>
<tr>
<td class="td1">ILDF G Branch</td>
<td class="td1">General Staff Branch</td>
</tr>
<tr>
<td class="td1">ILFM</td>
<td class="td1">Israel Foreign Minister</td>
</tr>
<tr>
<td class="td1">ILNF</td>
<td class="td1">Israel Naval Force (Navy)</td>
</tr>
<tr>
<td class="td1">ILPM</td>
<td class="td1">Israel Prime Minister</td>
</tr>
<tr>
<td class="td1">OPOR</td>
<td class="td1">Operation Order</td>
</tr>
<tr>
<td class="td1">ORBAT</td>
<td class="td1">Order of Battle</td>
</tr>
<tr>
<td class="td1">PC</td>
<td class="td1">Personal Collection</td>
</tr>
<tr>
<td class="td1">PXNE</td>
<td class="td1"><em class="italic">Phoenix over the Nile, a history of Egyptian air power 1932-1994</em>, Lon Nordeen and David Nicolle, 1996</td>
</tr>
<tr>
<td class="td1">RAF</td>
<td class="td1">Royal Air Force</td>
</tr>
<tr>
<td class="td1">RTB</td>
<td class="td1">Return to Base</td>
</tr>
<tr>
<td class="td1">TOT</td>
<td class="td1">Time On Target</td>
</tr>
<tr>
<td class="td1">UK</td>
<td class="td1">United Kingdom</td>
</tr>
<tr>
<td class="td1">UN</td>
<td class="td1">United Nations</td>
</tr>
<tr>
<td class="td1">USA</td>
<td class="td1">United States of America</td>
</tr>
<tr>
<td class="td1">USSR</td>
<td class="td1">Union of Soviet Socialist Republics</td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Glossary.vue?34850b46